export default __webpack_public_path__ + "static/media/deep-cleaning.27bf9d9c.svg";